import ProjectBrowsePodsManagementModalComponent from './project-browse-pods-management-modal.component'

export default ProjectBrowsePodsManagementModalComponent
